import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../component/shared/shared.service";
import { Patient, Search } from "../model/patient";
import { PatientService } from "../service/patient-service.service";
import { MedicalHistory } from "../../master/model/medical-history";
import { MedicalHistoryService } from "../../master/services/medical-history.service";
import {
  DialogAction,
  ActionMessage
} from "../../../shared/enum/dialog-action.enum";
@Component({
  selector: "app-view-patient",
  templateUrl: "./view-patient.component.html",
  styleUrls: ["./view-patient.component.css"]
})
export class ViewPatientComponent implements OnInit {
  loading: boolean = false;
  listLoading: boolean = false;
  search: Search = new Search("");
  Patients: Patient[];
  message: string = "";
  showEditPatient: boolean;
  searchAlphabets: string[];
  PatientsList: Patient[];
  filterText: string;
  medicalHistoryData: MedicalHistory[];
  selectedObject: Patient;
  user: any;
  constructor(
    private _sharedService: SharedService,
    private _usrService: PatientService,
    private _mhService: MedicalHistoryService
  ) {
    this.filterText = "All";
    this.searchAlphabets = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z"
    ];
    _sharedService.yesEmitted$.subscribe(text => {
      if (
        text.Action === DialogAction.DELETE.toString() &&
        text.Page === "PATIENTVIEW"
      ) {
        this.delete(text.Data);
      }
    });
    _sharedService.profileeditEmitted$.subscribe(text => {
      if (text.data !== undefined && text.data !== null) {
        this.setUpdatePatient(text.data);
      }
    });
  }
  editPatient(patientData): void {
    debugger;
    var historyData = this.medicalHistoryData;
    this._sharedService.overlay({
      module: "PATIENT",
      type: "Edit",
      isShow: true,
      data: patientData,
      secondData: historyData
    });
  }
  showMedicalHistory(patientData): void {
    var historyData = this.medicalHistoryData;
    this._sharedService.overlay({
      module: "PATIENT",
      type: "History",
      isShow: true,
      data: patientData,
      secondData: historyData
    });
  }
  deletePatient(patientData): void {
    this.selectedObject = patientData;
    this._sharedService.emitDialog(
      true,
      "Delete",
      ActionMessage.DELETE.toString(),
      true,
      DialogAction.DELETE.toString(),
      "PATIENTVIEW",
      patientData
    );
  }
  setUpdatePatient(patientObj: Patient) {
    this.getPatients();
  }
  delete(data: Patient): void {
    this.loading = true;
    this._usrService.deletePatient(data).subscribe(
      data => {
        this.listLoading = false;
        this.message = "User " + ActionMessage.DELETESUCCESS.toString();

        this.getPatients();
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  searchPatient(): void {
    if (this.search.text.length < 2) {
      return;
    }
    this.Patients = [];
    this.getPatients();
    /*var txtSearch = this.search.text;
    var filterData = null;
    var fText = this.filterText;
    if(fText  !== 'All') {
      filterData  = this.PatientsList.filter(function(user){
        return (user.PatientFirstName.toUpperCase() .indexOf(fText.toUpperCase())===0);
      })
      
    } else {
      filterData = this.PatientsList;
    }
    if( txtSearch !== '') {
      var data = filterData.filter(function(user){
        return ((user.PatientFirstName.toUpperCase()+ ' ' +user.PatientLastName.toUpperCase()).replace(/\s/g,'').indexOf( txtSearch.toUpperCase().replace(/\s/g,'') )>-1|| user.PatientLastName.toUpperCase().indexOf( txtSearch.toUpperCase() )>-1 || user.PatientEmailAddress.toUpperCase().indexOf( txtSearch.toUpperCase() )>-1 || user.PatientPrimaryMobNo.toString().toUpperCase().indexOf( txtSearch.toUpperCase() )>-1 || user.Patient_PIN.toUpperCase().indexOf( txtSearch.toUpperCase() )>-1);
      })
      if(data.length>0){
        this.Patients = data;     
      } 
    } else {
      this.Patients = filterData;
    }*/
  }

  closePopup(): void {
    this.showEditPatient = false;
    this._sharedService.overlay(this.showEditPatient);
  }
  filterByAlphabet(txt: string) {
    this.search = new Search("");
    this.filterText = txt;
    this.Patients = [];
    this.getPatients();
    /* if(txt !== 'All') {
      var data = this.PatientsList.filter(function(user){
        return (user.PatientFirstName.toUpperCase().indexOf(txt.toUpperCase())===0);
      })
      if(data.length>0){
        this.Patients = data;     
      } 
    } else {
      this.Patients = this.PatientsList.slice(0,100);
    }*/
  }

  getPatients(): void {
    this.loading = true;
    var txtSearch = this.search.text;
    var fText = this.filterText;
    this._usrService.getPatientForSearch(fText, txtSearch).subscribe(
      data => {
        this.loading = false;

        this.Patients = data;
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  getMedicalHistory(): void {
    this.listLoading = true;
    this._mhService.getMedicalHistory().subscribe(
      data => {
        this.medicalHistoryData = data;
      },
      error => {}
    );
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    // if(sessionStorage.getItem("data") == undefined) {
    this.getPatients();
    //} else {
    //  this.Patients  = JSON.parse(sessionStorage.getItem("data")).slice(0,100);
    //  this.PatientsList = JSON.parse(sessionStorage.getItem("data"));
    //}

    this.getMedicalHistory();
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  bookAppointment(patient: Patient) {
    this._sharedService.overlay({
      module: "USER",
      type: "Appointment",
      isShow: true,
      data: null,
      secondData: patient
    });
  }

  export() {
    this.loading = true;

    this._usrService.getFiles().subscribe(
      data => {
        this.loading = false;
        const arr = new Uint8Array(data["_body"] as ArrayBuffer);
        const blob = new Blob([arr], {
          type: "application/vnd.ms-excel"
        });
        this.downloadFile(blob, "Record.xls");
      },
      error => {
        this.loading = false;
      }
    );
  }
  downloadFile(file: Blob, fileName: string): boolean {
    if (!file || !fileName) {
      return false;
    }
    try {
      const objectURL = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = objectURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      return true;
    } catch {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/section/patient/view-patient/view-patient.component.ts